import { NgModule } from '@angular/core';
import { ZipCodesTextareaDirective } from './zip-codes-textarea.directive';

@NgModule({
    declarations: [ZipCodesTextareaDirective],
    exports: [ZipCodesTextareaDirective],
})
export class ZipCodesTextareaDirectiveModule {}
